import "./App.css";
import { useState, useEffect, useContext, useCallback } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { precioPais } from "./controller/api";
import Login from "./layout/Login";
import ProtectedRoute from "./ProtectedRoute";
import Dashboard from "./layout/Dashboard";
import SmartSolutions from "./layout/SmartSolutions";
import { MyContext } from "./context/Context";
import Header from "./components/Header";
import FormWeb from "./components/FormWeb";
import Informes from "./components/Informes";
import Modal from "./components/Modal";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [precio, setPrecio] = useState(null);
  const { isModalOpen, toggleModal, userTipo } = useContext(MyContext);
  console.log(precio, 'hola');

  // ✅ Función para obtener precios por país
  const fetchPreciosPais = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.pais) return;

      const data = await precioPais(user.pais);
      const precioRedondeado = Math.ceil(data.hora_trabajo);

      setPrecio(precioRedondeado);
      localStorage.setItem("precio", JSON.stringify(precioRedondeado));
    } catch (error) {
      console.error("Error al obtener los precios por país:", error);
    }
  }, []);

  // ✅ Verificar autenticación al cargar
  useEffect(() => {
    try {
      const authData = JSON.parse(localStorage.getItem("authData"));

      if (authData && authData.isAuthenticated && authData.expiry > Date.now()) {
        setIsAuthenticated(true);
      } else {
        localStorage.removeItem("authData");
        setIsAuthenticated(false);
      }
    } catch (error) {
      console.error("Error al leer authData:", error);
      setIsAuthenticated(false);
    }
  }, []);

  // ✅ Obtener precios cuando cambia autenticación o se abre/cierra modal
  useEffect(() => {
    if (!isAuthenticated) return;
    console.log(isModalOpen, 'modal');

    if (isModalOpen) {
      // Paso 1: al abrir el modal, resetear el precio a 1
      localStorage.setItem("precio", JSON.stringify(1));
      window.dispatchEvent(new Event("storage"));
      setPrecio(1);

      // Paso 2: luego cargar el precio real del usuario
      fetchPreciosPais();
    } else {
      // Si el modal se cierra, simplemente actualiza desde la API
      fetchPreciosPais();
    }
  }, [ isModalOpen]);


  // ✅ Escuchar cambios en localStorage (user o authData)
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (["user", "authData"].includes(event.key)) fetchPreciosPais();
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [fetchPreciosPais]);

  // ✅ Manejo de login
  const handleLogin = (isLoggedIn) => {
    setIsAuthenticated(isLoggedIn);

    if (isLoggedIn) {
      const expiry = Date.now() + 2 * 60 * 60 * 1000;
      localStorage.setItem(
        "authData",
        JSON.stringify({ isAuthenticated: true, expiry })
      );
    } else {
      localStorage.removeItem("authData");
    }
  };

  return (
    <>
      <Modal isOpen={isModalOpen} onClose={toggleModal} />

      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />

        <Route
          path="/"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div className="main-layout">
                <Header toggleModal={toggleModal} userTipo={userTipo} />
                <Dashboard />
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/webEsencial"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div className="main-layout">
                <Header toggleModal={toggleModal} userTipo={userTipo} />
                <div className="dashboard">
                  <FormWeb />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/smarSolution"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div className="main-layout">
                <Header toggleModal={toggleModal} userTipo={userTipo} />
                <div className="dashboard">
                  <SmartSolutions />
                </div>
              </div>
            </ProtectedRoute>
          }
        />

        <Route
          path="/Informes"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <div className="main-layout">
                <Header toggleModal={toggleModal} userTipo={userTipo} />
                <div className="dashboard">
                  <Informes />
                </div>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

export default App;
